import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faCalendarAlt, faEdit, faFileWord, faFilter, faGavel, faHashtag, faPlus, faSearch, faSync, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        estadoCuentas: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    ListarEstadoCuentas(page) {
        Swal.showLoading();
        let betapa = 0;
        let bname;
        let btipo_busqueda = document.getElementById('btipo_busqueda').value;
        if (btipo_busqueda === 'etapa') {
            bname = 0;
            betapa = document.getElementById('betapa').value;
        } else {
            bname = document.getElementById('bnombre').value;
        }
        if (btipo_busqueda == '') {
            btipo_busqueda = 0;
        }
        if (bname == '') {
            bname = 0;
        }
        if (betapa == '') {
            betapa = 0;
        }
        authAxios.get("estado_cuentas/index/" + btipo_busqueda + "/" + betapa + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', estadoCuentas: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarEstadoCuentas(1);
    }
    render() {
        const { load, btipo_busqueda, estadoCuentas, pagina, ultimo, actual } = this.state;
        return (
            <>
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header">
                                {/* <Link className="btn btn-success btn-sm" to={"/AddGenerarEstadoCuentas"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Gestión Cobro</Link>&nbsp;&nbsp; */}
                                <Link className='btn btn-secondary btn-sm' to={"/ConsultarCartera"}><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Consultar Cartera</Link>
                            </div>
                            <div className="card-body">
                                <h4>Lista Gestión de Cobro Generados</h4>
                                <hr />
                                <div className="row">
                                    <div className="col-xl-2">
                                        <select name="btipo_busqueda" id="btipo_busqueda"
                                            className={"form-select form-select-sm"}
                                            onChange={this.cambioValor}>
                                                <option value="">-</option>
                                                <option value="nic">NIC</option>
                                                <option value="etapa">ETAPA</option>
                                                <option value="municipio">MUNICIPIO</option>
                                                <option value="contribuyente">CONTRIBUYENTE</option>
                                        </select>
                                    </div>
                                    {
                                        btipo_busqueda === 'etapa' ?
                                            <div className="col-xl-2">
                                                <select name="betapa"
                                                    id="betapa"
                                                    className="form-select form-select-sm"
                                                    onChange={this.cambioValor}>
                                                    <option value="">Seleccione la Etapa</option>
                                                    <option value="1">COBRO PERSUASIVO</option>
                                                    <option value="2">COBRO COACTIVO</option>
                                                </select>
                                            </div>
                                        : null
                                    }
                                    {
                                        btipo_busqueda !== 'etapa' ?
                                            <div className="col-xl-4">
                                                <input type="text" id="bnombre" name="bnombre"
                                                 style={{ textTransform: 'uppercase' }} placeholder="GESTIÓN COBRO"
                                                 className="form-control form-control-sm"
                                                 onChange={this.cambioValor} />
                                            </div>
                                        : null
                                    }
                                    <div className="col-xl-3">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarEstadoCuentas(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle"># EXPEDIENTE</th>
                                                <th className="align-middle">NIC</th>
                                                <th className="align-middle">CONTRIBUYENTE</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                {/* <th className="align-middle">ETAPA</th>
                                                <th className="align-middle">ESTADO</th> */}
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                estadoCuentas.map((itemEstadoCuentas) => (
                                                    <tr key={itemEstadoCuentas.ID_ESTADO_CUENTA}>
                                                        <td>EXP-{itemEstadoCuentas.ID_ESTADO_CUENTA}</td>
                                                        <td>{itemEstadoCuentas.NIC}</td>
                                                        <td>{itemEstadoCuentas.NOMBRE_PROPIETARIO}</td>
                                                        <td>{itemEstadoCuentas.DEPARTAMENTO}</td>
                                                        <td>{itemEstadoCuentas.MUNICIPIO}</td>
                                                        {/* {
                                                            (() => {
                                                                switch (itemEstadoCuentas.ETAPA_ESTADO_CUENTA) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-info">CP</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-info">CC</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        {
                                                            (() => {
                                                                switch (itemEstadoCuentas.ESTADO_ESTADO_CUENTA) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">N</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-secondary">CG</span></td>)
                                                                    case 3:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">CNG</span></td>)
                                                                    case 4:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">CA</span></td>)
                                                                    case 5:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-warning">CEA</span></td>)

                                                                }
                                                            })()
                                                        } */}
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpEstadoCuentas/" + itemEstadoCuentas.ID_ESTADO_CUENTA}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemEstadoCuentas.ID_ESTADO_CUENTA)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>&nbsp;&nbsp;
                                                                {/* <button
                                                                    type="button"
                                                                    className="btn btn-info btn-sm"
                                                                    onClick={() =>
                                                                        this.descargarCobroPersuasivo(itemEstadoCuentas.NIC)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon style={{color: '#FFFFFF'}} icon={faFileWord} />
                                                                </button> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarEstadoCuentas(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarEstadoCuentas(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarEstadoCuentas(actual)}>{actual}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarEstadoCuentas(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarEstadoCuentas(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                                {/* <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">N</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>NOTIFICADO</b></span>&nbsp;
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-secondary">CG</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>CARTA GENERADA</b></span>&nbsp;
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">CNG</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>CARTA NO GENERADA</b></span>&nbsp;
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">CA</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>CARTA APROBADA</b></span>&nbsp;
                                <span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF' }} className="badge bg-warning">CEA</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>CARTA ENVIADA APROBACIÓN</b></span>
                                <br />
                                <span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF' }} className="badge bg-info">CP</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>COBRO PERSUASIVO</b></span>&nbsp;
                                <span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF' }} className="badge bg-info">CC</span>
                                <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>COBRO COACTIVO</b></span>&nbsp; */}
                            </div>
                            <div className="card-footer text-muted">
                                <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Listar;